/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { OpenShiftResponse } from './OpenShiftResponse';
import {
    OpenShiftResponseFromJSON,
    OpenShiftResponseFromJSONTyped,
    OpenShiftResponseToJSON,
    OpenShiftResponseToJSONTyped,
} from './OpenShiftResponse';

/**
 * 
 * @export
 * @interface ListOpenShiftResponsesResponse
 */
export interface ListOpenShiftResponsesResponse {
    /**
     * 
     * @type {Array<OpenShiftResponse>}
     * @memberof ListOpenShiftResponsesResponse
     */
    data: Array<OpenShiftResponse>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListOpenShiftResponsesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListOpenShiftResponsesResponse interface.
 */
export function instanceOfListOpenShiftResponsesResponse(value: object): value is ListOpenShiftResponsesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListOpenShiftResponsesResponseFromJSON(json: any): ListOpenShiftResponsesResponse {
    return ListOpenShiftResponsesResponseFromJSONTyped(json, false);
}

export function ListOpenShiftResponsesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOpenShiftResponsesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OpenShiftResponseFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListOpenShiftResponsesResponseToJSON(json: any): ListOpenShiftResponsesResponse {
      return ListOpenShiftResponsesResponseToJSONTyped(json, false);
  }

  export function ListOpenShiftResponsesResponseToJSONTyped(value?: ListOpenShiftResponsesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OpenShiftResponseToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

